module.exports = __webpack_public_path__ + "media/images/hamburger-black-3d97b02c.svg";